import React from "react";
import { Linking } from "react-native";
import { YStack, Text } from "tamagui";

type EventDetailDescriptionProps = {
  description: string | null | undefined;
};

export const EventDetailDescription = ({
  description,
}: EventDetailDescriptionProps) => {
  const renderDescription = () => {
    if (!description) {
      return (
        <Text>
          {`We're still working on the details for this one! Check back later for more information!`}
        </Text>
      );
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);

    return (
      <Text>
        {parts.map((part, index) => {
          if (urlRegex.test(part)) {
            return (
              <Text
                key={`link-${index}`}
                onPress={() => Linking.openURL(part)}
                color="$blue7Dark"
              >
                {part}
              </Text>
            );
          } else {
            return <Text key={`text-${index}`}>{part}</Text>;
          }
        })}
      </Text>
    );
  };

  return <YStack>{renderDescription()}</YStack>;
};
